import axios from 'axios';
import get from 'lodash.get';
import { LogService } from '../../services/log-service';
import { from } from 'rxjs';

export const getAnnouncements = () => {
  const result = axios
    .get('/announcements')
    .then((response) => get(response, 'data', []))
    .catch((e) => {
      LogService.logError(new Error('Error occurred while getting announcements', { cause: e }));
      return [];
    });
  return from(result);
};

export const dismissAnnouncement = (announcementId) => {
  axios
    .put(`/announcements/${announcementId}/dismiss`)
    .catch((e) => LogService.logError(new Error('Error occurred while dismissing announcement', { cause: e }), { announcementId }));
};
